(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81187],{

/***/ 87193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65122);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var GridList = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function GridList(props, ref) {
  var _props$cellHeight = props.cellHeight,
      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
      style = props.style,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
    ref: ref,
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      margin: -spacing / 2
    }, style)
  }, other), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
      return null;
    }

    if (false) {}

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiGridList'
})(GridList));

/***/ }),

/***/ 45332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74902);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79437);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _utils_isMuiElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83711);









var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      fit(imgEl, classes);
    });
  }
}

var GridListTile = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function GridListTile(props, ref) {
  // cols rows default values are for docs only
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    ensureImageCover(imgRef.current, classes);
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function () {
      fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.tile
  }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
      return null;
    }

    if (child.type === 'img' || (0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(child, ['Image'])) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiGridListTile'
})(GridListTile));

/***/ }),

/***/ 69853:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confirmation",
      function () {
        return __webpack_require__(80625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87193);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45332);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22318);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86700);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var moduleHeight = 218;
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        marginNull: {
            margin: 0
        },
        paddingNull: {
            padding: 0
        },
        padding: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6)
        },
        instaWall: {
            position: 'relative',
            minHeight: moduleHeight * 1.5
        },
        insta: _defineProperty({
            minHeight: moduleHeight,
            maxWidth: 407,
            minWidth: 300,
            padding: 5,
            borderRadius: theme.shape.borderRadius,
            position: 'absolute',
            backgroundColor: theme.palette.common.white,
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)'
        }, theme.breakpoints.up('lg'), {
            minWidth: 407
        }),
        instaBox: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: "1px solid ".concat(theme.palette.primary.main),
            minHeight: 218,
            borderRadius: theme.shape.borderRadius * 0.75,
            textAlign: 'center',
            padding: '10px'
        },
        share: _defineProperty({}, theme.breakpoints.up('md'), {
            padding: 10
        }),
        logoInsta: {
            paddingBottom: '10px',
            width: 50
        },
        gridImg: {
            objectFit: 'cover'
        }
    });
});
var InstaWall = function(param) {
    var _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, data = param.data, t = param.t;
    var ref3, ref1, ref2;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var images = data === null || data === void 0 ? void 0 : data.instagramimages;
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().trackEvent;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "section-instawall ".concat(classes.instaWall),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            maxWidth: "xl",
            className: isSmall ? classes.paddingNull : classes.padding,
            children: [
                images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    container: true,
                    justify: "center",
                    children: !isSmall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        cellHeight: 154,
                        cols: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.up('md')) ? 7 : 2,
                        spacing: 9,
                        children: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.up('md')) ? images.map(function(tile, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                cols: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: classes.gridImg,
                                    src: tile.image.url,
                                    alt: tile.image.alt === null ? '' : tile.image.alt
                                })
                            }, index);
                        }) : images.slice(0, 4).map(function(tile, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                cols: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: classes.gridImg,
                                    src: tile.image.url,
                                    alt: tile.image.alt === null ? '' : tile.image.alt
                                })
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        cellHeight: 154,
                        cols: 2,
                        spacing: 9,
                        children: images.slice(0, 4).map(function(tile, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                cols: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: tile.image.url,
                                    alt: tile.image.alt === null ? '' : tile.image.alt
                                })
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.insta,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classes.instaBox,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (data === null || data === void 0 ? void 0 : (ref3 = data.instagramlogo) === null || ref3 === void 0 ? void 0 : ref3.url) ? data.instagramlogo.url : '/images/placeholder.jpg',
                                alt: "Instagram",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(classes.logoInsta, 'instagram__logo')
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "h4",
                                component: "h2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: data === null || data === void 0 ? void 0 : data.title,
                                    defaultText: t('texts:instagramwall:title')
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classes.share,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    color: 'secondary',
                                    component: "div",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: data === null || data === void 0 ? void 0 : data.desc,
                                        defaultText: t('texts:instagramwall:desc')
                                    })
                                })
                            }),
                            ((ref1 = data === null || data === void 0 ? void 0 : data.buttontext[0]) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                size: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.down('md')) ? 'small' : 'large',
                                variant: "contained",
                                className: "instaWall__instaButton",
                                onClick: function() {
                                    var ref;
                                    return trackEvent({
                                        category: 'HomePage',
                                        href: data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.url,
                                        action: "Universe Section leave website to instagram profile page"
                                    });
                                },
                                color: "primary",
                                href: (data === null || data === void 0 ? void 0 : (ref2 = data.link) === null || ref2 === void 0 ? void 0 : ref2.url) ? data.link.url : '/',
                                target: "blank",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: data === null || data === void 0 ? void 0 : data.buttontext,
                                    defaultText: t('texts:instagramwall:buttontext')
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InstaWall);


/***/ }),

/***/ 80625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ confirmation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./components/InstaWall/InstaWall.tsx
var InstaWall = __webpack_require__(52965);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./redux/actions/inStore.ts + 1 modules
var inStore = __webpack_require__(7766);
// EXTERNAL MODULE: ./redux/actions/order.ts
var order = __webpack_require__(46194);
// EXTERNAL MODULE: ./redux/actions/user.ts
var user = __webpack_require__(76809);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./components/Order/OrderProductRow.tsx
var OrderProductRow = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./components/Shop/TaxonPromotionBadge.tsx
var TaxonPromotionBadge = __webpack_require__(96780);
;// CONCATENATED MODULE: ./components/Order/OrderSecondHandProductRow.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        productCard: _defineProperty({
            minHeight: 70,
            font: '12px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up('md'), {
            padding: theme.spacing(1)
        }),
        checkBox: {},
        imgContainer: _defineProperty({
            display: 'flex',
            alignItems: 'center',
            width: 85,
            height: 85,
            position: 'relative',
            marginRight: theme.spacing(1)
        }, theme.breakpoints.up('md'), {
            marginRight: theme.spacing(2),
            width: 50,
            height: 50
        }),
        imgProduct: _defineProperty({
            width: '100%',
            objectFit: 'contain',
            marginLeft: theme.spacing(0)
        }, theme.breakpoints.up('md'), {}),
        productInformation: _defineProperty({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            width: '100%'
        }, theme.breakpoints.up('md'), {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
        }),
        productName: _defineProperty({
            display: 'flex',
            alignItems: 'baseline'
        }, theme.breakpoints.up('md'), {}),
        productNameString: _defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: 11
        }),
        productQuantity: {
            width: '10%'
        },
        smallerText: (_obj = {
            fontSize: 13
        }, _defineProperty(_obj, theme.breakpoints.down('md'), {
            fontSize: 10
        }), _defineProperty(_obj, "whiteSpace", 'nowrap'), _obj),
        productPrice: {
            display: 'flex',
            alignItems: 'flex-end'
        },
        productContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            width: '100%'
        }
    });
});
var OrderSecondHandProductRow = function(param) {
    var productName = param.productName, productImage = param.productImage, productPrice = param.productPrice, productState = param.productState, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity, settings = param.settings, taxonPromotionPercent = param.taxonPromotionPercent;
    var ref;
    var classes = useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.productCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.imgContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: productImage !== null && productImage !== void 0 ? productImage : settings === null || settings === void 0 ? void 0 : (ref = settings.default_image) === null || ref === void 0 ? void 0 : ref.url,
                        alt: productName,
                        className: classes.imgProduct
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.productContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonPromotionBadge/* default */.Z, {
                        percent: taxonPromotionPercent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.productInformation,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.productName, 'recapOrder__product-name'),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        children: [
                                            "x",
                                            quantity
                                        ]
                                    }),
                                    "\xa0",
                                    isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h5',
                                        className: classes.productNameString,
                                        children: (0,utils/* truncateString */.aS)(productName, 24)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h5',
                                        children: productName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'h5',
                                className: (0,clsx_m/* default */.Z)(classes.productNameString, 'recapOrder__product-state'),
                                children: productState
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                className: (0,clsx_m/* default */.Z)(classes.smallerText, 'recapOrder__product-price'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                    amount: productPrice,
                                    showDayOrMonth: false
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Order_OrderSecondHandProductRow = (OrderSecondHandProductRow);

// EXTERNAL MODULE: ./utils/cart.tsx
var utils_cart = __webpack_require__(89910);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
;// CONCATENATED MODULE: ./components/Order/RecapOrder.tsx






















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RecapOrder_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var customParseFormat = __webpack_require__(10285);
dayjs_min_default().extend(customParseFormat);
var RecapOrder_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: RecapOrder_defineProperty({
            padding: theme.spacing(2, 1, 4)
        }, theme.breakpoints.down('md'), {
            padding: 0,
            marginBottom: theme.spacing(6)
        }),
        alignCenter: {
            textAlign: 'center'
        },
        lastOrderContainer: {
            display: 'inline-flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        },
        button: RecapOrder_defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: 12,
            padding: theme.spacing(0.5, 1)
        }),
        orderTotals: {
            marginTop: theme.spacing(2),
            paddingTop: theme.spacing(1)
        },
        orderTotalsRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(1, 0.5),
            borderTop: "1px solid ".concat(theme.extraColors.greyLight)
        },
        promotionAmount: {
            color: theme.palette.success.main
        },
        confirmationRecapOrder: {
            margin: theme.spacing(2, 0)
        }
    });
});
var mapStateToProps = function(state) {
    return {
        user: state.user,
        returnProducts: state.returnProducts,
        cart: state.cart,
        parameters: state.parameters
    };
};
var mapDispatchToProps = {
    getUser: user/* getUser */.PR,
    getUserOrders: user/* getUserOrders */.uI,
    getStoresByOrderId: inStore/* getStoresByOrderId */.f0,
    postProductToReturn: order/* postProductToReturn */.Gv
};
var RecapOrder = function(param1) {
    var user = param1.user, parameters = param1.parameters, cart = param1.cart, t = param1.t, getStoresByOrderId1 = param1.getStoresByOrderId, doc = param1.doc, settings = param1.settings, returnProducts = param1.returnProducts, postProductToReturn1 = param1.postProductToReturn, showPrice = param1.showPrice, showSizes = param1.showSizes, lastOrder = param1.lastOrder, takeBack = param1.takeBack, getUser1 = param1.getUser;
    var ref16, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var classes = RecapOrder_useStyles();
    var router = (0,next_router.useRouter)();
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var states = productCheckState(takeBack);
    var ref15 = (0,react.useState)([]), warehouses = ref15[0], setWarehouses = ref15[1];
    var secondHandLastOrder = lastOrder === null || lastOrder === void 0 ? void 0 : (ref16 = lastOrder.items) === null || ref16 === void 0 ? void 0 : ref16.filter(function(item) {
        return item.type === constants/* ORDER_ITEM_TYPE.SECOND_HAND */._$.SECOND_HAND;
    });
    var rentalOrPurchaseLastOrder = lastOrder === null || lastOrder === void 0 ? void 0 : (ref1 = lastOrder.items) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item.type === constants/* ORDER_ITEM_TYPE.RENTAL */._$.RENTAL || item.type === constants/* ORDER_ITEM_TYPE.PURCHASE */._$.PURCHASE;
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id)) {
            var getUserOrRedirect = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var isUser;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getUser1();
                            case 2:
                                isUser = _ctx.sent;
                                if (isUser.type === 'GET_USER_FAILURE') {
                                    //No redirect if in debug mode
                                    if (router.asPath !== constants/* DEBUG */.eM) {
                                    //user has no valid jwt token, ie he's disconnected
                                    //router.push('/')
                                    }
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function getUserOrRedirect() {
                    return _ref.apply(this, arguments);
                };
            }();
            getUserOrRedirect();
        }
    }, [
        user === null || user === void 0 ? void 0 : (ref2 = user.user) === null || ref2 === void 0 ? void 0 : ref2.id,
        router
    ]);
    (0,react.useEffect)(function() {
        var Async = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref18, ref17, orderNumbers, response, warehouseOrdersProducts;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (!((parameters === null || parameters === void 0 ? void 0 : (ref18 = parameters.items) === null || ref18 === void 0 ? void 0 : ref18.in_store) && (returnProducts === null || returnProducts === void 0 ? void 0 : returnProducts.items))) {
                                _ctx.next = 9;
                                break;
                            }
                            ;
                            orderNumbers = [];
                            returnProducts === null || returnProducts === void 0 ? void 0 : (ref17 = returnProducts.items) === null || ref17 === void 0 ? void 0 : ref17.map(function(product) {
                                orderNumbers.push(product.orderNumber);
                            });
                            _ctx.next = 7;
                            return getStoresByOrderId1(orderNumbers);
                        case 7:
                            response = _ctx.sent;
                            if ((response === null || response === void 0 ? void 0 : response.type) === 'GET_STORES_BY_ORDER_NUMBER_SUCCESS') {
                                setWarehouses(response === null || response === void 0 ? void 0 : response.stores);
                                warehouseOrdersProducts = [];
                                response === null || response === void 0 ? void 0 : response.stores.map(function(warehouse, indexWarehouse) {
                                    var ref20;
                                    warehouseOrdersProducts.push({
                                        name: warehouse.name,
                                        address: warehouse.address,
                                        city: warehouse.city,
                                        orders: []
                                    });
                                    warehouse === null || warehouse === void 0 ? void 0 : (ref20 = warehouse.orders) === null || ref20 === void 0 ? void 0 : ref20.map(function(whOrder) {
                                        if (typeof returnProducts.items.find(function(returnedProduct) {
                                            return returnedProduct.orderNumber === whOrder.orderNumber;
                                        }) !== 'undefined') {
                                            var ref, ref19;
                                            var order = returnProducts.items.find(function(returnedProduct) {
                                                return returnedProduct.orderNumber === whOrder.orderNumber;
                                            });
                                            warehouseOrdersProducts[indexWarehouse].orders.push({
                                                number: order.orderNumber,
                                                tokenValue: order.orderToken,
                                                products: [
                                                    {
                                                        product: order.product,
                                                        puid: (ref19 = whOrder === null || whOrder === void 0 ? void 0 : (ref = whOrder.products) === null || ref === void 0 ? void 0 : ref.find(function(product) {
                                                            return product.sku === order.Sku;
                                                        })) === null || ref19 === void 0 ? void 0 : ref19.id,
                                                        totalWithoutPromotion: order.total
                                                    }, 
                                                ]
                                            });
                                        }
                                    });
                                });
                                setWarehouses(warehouseOrdersProducts);
                            }
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function Async() {
                return _ref.apply(this, arguments);
            };
        }();
        Async();
    }, [
        returnProducts
    ]);
    var downloadPdf = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref21, data, products, response, ref22;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        data = [];
                        returnProducts === null || returnProducts === void 0 ? void 0 : (ref = returnProducts.items) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                            data === null || data === void 0 ? void 0 : data.push({
                                lizeeSKU: product === null || product === void 0 ? void 0 : product.Sku,
                                quantity: product === null || product === void 0 ? void 0 : product.quantity
                            });
                        });
                        products = {
                            products: data,
                            gender: user === null || user === void 0 ? void 0 : (ref21 = user.user) === null || ref21 === void 0 ? void 0 : ref21.gender
                        };
                        _ctx.next = 6;
                        return postProductToReturn1(products);
                    case 6:
                        response = _ctx.sent;
                        if (response.type === 'POST_PRODUCT_TO_RETURN_SUCCESS') {
                            ;
                            if ((ref22 = response === null || response === void 0 ? void 0 : response.response[0]) === null || ref22 === void 0 ? void 0 : ref22.pdfUrl) {
                                (0,utils/* downloadURI */.l_)(response.response[0].pdfUrl, "".concat("millet", "_").concat(response.response[0].trackingCode));
                            }
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function downloadPdf() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(classes.alignCenter, 'recapOrder__title'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'h3',
                    color: 'secondary',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.title,
                        defaultText: t('texts:confirmation:title')
                    })
                })
            }),
            (returnProducts === null || returnProducts === void 0 ? void 0 : (ref4 = returnProducts.items) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && !(parameters === null || parameters === void 0 ? void 0 : (ref5 = parameters.items) === null || ref5 === void 0 ? void 0 : ref5.in_store) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.lastOrderContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: 'h5',
                                className: "recapOrder__date",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.articles_return,
                                        defaultText: t('texts:confirmation:articles_return')
                                    }),
                                    "\xa0",
                                    dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref7 = cart.item) === null || ref7 === void 0 ? void 0 : ref7.endLeasingDate, 'DD/MM/YYYY').subtract(2, 'day').format('L')
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: 'contained',
                                color: 'secondary',
                                size: 'small',
                                onClick: function() {
                                    return downloadPdf();
                                },
                                className: classes.button,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.generate_vouchers,
                                    defaultText: t('texts:confirmation:generate_vouchers')
                                })
                            })
                        ]
                    }),
                    returnProducts === null || returnProducts === void 0 ? void 0 : (ref9 = returnProducts.items) === null || ref9 === void 0 ? void 0 : ref9.map(function(item, index) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                t: t,
                                settings: settings,
                                item: item,
                                index: index,
                                showSizes: showSizes
                            })
                        }, index));
                    })
                ]
            }),
            (parameters === null || parameters === void 0 ? void 0 : (ref10 = parameters.items) === null || ref10 === void 0 ? void 0 : ref10.in_store) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: warehouses.map(function(warehouse) {
                    var ref;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.lastOrderContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: 'h4',
                                        children: [
                                            t('texts:confirmation:to_return'),
                                            ' ',
                                            warehouse.name + ' ' + warehouse.address
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: 'contained',
                                        color: 'secondary',
                                        size: 'small',
                                        onClick: function() {
                                            return downloadPdf();
                                        },
                                        className: classes.button,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.generate_vouchers,
                                            defaultText: t('texts:confirmation:generate_vouchers')
                                        })
                                    })
                                ]
                            }),
                            warehouse.orders.map(function(order) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: order.products.map(function(item, index) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                                t: t,
                                                settings: settings,
                                                showSizes: showSizes,
                                                item: item,
                                                showQuantity: true,
                                                orderNumber: order.number,
                                                index: index,
                                                showPrice: showPrice
                                            })
                                        }, index));
                                    })
                                }));
                            })
                        ]
                    }));
                })
            }),
            (user === null || user === void 0 ? void 0 : (ref11 = user.orders) === null || ref11 === void 0 ? void 0 : ref11.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.lastOrderContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: 'h5',
                                className: "recapOrder__date",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.articles_to_send,
                                        defaultText: t('texts:confirmation:articles_to_send')
                                    }),
                                    "\xa0",
                                    dayjs_min_default()(lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.startLeasingDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: 'account',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: 'outlined',
                                        color: 'secondary',
                                        size: 'small',
                                        className: (0,clsx_m/* default */.Z)(classes.button, 'recapOrder__account_cta'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.account_cta,
                                            defaultText: t('texts:confirmation:account_cta')
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: 'h4',
                        children: [
                            t('texts:confirmation:order_number'),
                            ' ',
                            (lastOrder === null || lastOrder === void 0 ? void 0 : (ref14 = lastOrder.items) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && (lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.number)
                        ]
                    }),
                    rentalOrPurchaseLastOrder === null || rentalOrPurchaseLastOrder === void 0 ? void 0 : rentalOrPurchaseLastOrder.map(function(item, index) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.confirmationRecapOrder,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                t: t,
                                settings: settings,
                                showSizes: showSizes,
                                item: item,
                                index: index,
                                showQuantity: true,
                                isBought: (0,utils/* isPurchasedItem */.mo)(item),
                                isConfirmation: true,
                                showPrice: showPrice,
                                currency: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.currency
                            })
                        }, index));
                    }),
                    secondHandLastOrder === null || secondHandLastOrder === void 0 ? void 0 : secondHandLastOrder.map(function(item) {
                        var ref24;
                        var currentProduct = (0,utils_cart/* getSecondHandProductInformation */.Lj)(item);
                        // Group units by quality if quantity selector is enabled
                        if (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector) {
                            var ref23;
                            // Group by productState (quality)
                            var groupedByQuality = currentProduct === null || currentProduct === void 0 ? void 0 : (ref23 = currentProduct.units) === null || ref23 === void 0 ? void 0 : ref23.reduce(function(acc, unit) {
                                var quality = unit === null || unit === void 0 ? void 0 : unit.productState;
                                if (!acc[quality]) {
                                    acc[quality] = {
                                        units: [],
                                        totalPrice: 0
                                    };
                                }
                                acc[quality].units.push(unit);
                                acc[quality].totalPrice += (unit === null || unit === void 0 ? void 0 : unit.productPrice) || 0;
                                return acc;
                            }, {});
                            return Object.entries(groupedByQuality || {}).map(function(param) {
                                var _param = _slicedToArray(param, 2), quality = _param[0], groupData = _param[1];
                                var ref;
                                var group = groupData;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.confirmationRecapOrder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_OrderSecondHandProductRow, {
                                        settings: settings,
                                        productName: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productName,
                                        productImage: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productImage,
                                        productPrice: group.totalPrice,
                                        productState: (ref = states["".concat(quality)]) === null || ref === void 0 ? void 0 : ref.title,
                                        quantity: group.units.length,
                                        taxonPromotionPercent: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.taxonPromotionPercent
                                    })
                                }, "".concat(item.id, "-").concat(quality)));
                            });
                        }
                        // Default behavior: display each unit individually
                        return currentProduct === null || currentProduct === void 0 ? void 0 : (ref24 = currentProduct.units) === null || ref24 === void 0 ? void 0 : ref24.map(function(unit, index) {
                            var ref;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.confirmationRecapOrder,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_OrderSecondHandProductRow, {
                                    settings: settings,
                                    productName: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productName,
                                    productImage: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productImage,
                                    productPrice: unit === null || unit === void 0 ? void 0 : unit.productPrice,
                                    productState: (ref = states["".concat(unit === null || unit === void 0 ? void 0 : unit.productState)]) === null || ref === void 0 ? void 0 : ref.title,
                                    taxonPromotionPercent: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.taxonPromotionPercent
                                })
                            }, index));
                        });
                    }),
                    showPrice && (lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.totals) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.orderTotals,
                        children: [
                            lastOrder.totals.promotion !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.orderTotalsRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t('texts:basket:reduction')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        className: (0,clsx_m/* default */.Z)(classes.promotionAmount),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: lastOrder.totals.promotion,
                                                showDayOrMonth: false,
                                                currency: lastOrder.currency
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.orderTotalsRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: t('texts:basket:total_with_subscription')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: lastOrder.totals.total,
                                                showDayOrMonth: false,
                                                currency: lastOrder.currency
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Order_RecapOrder = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(RecapOrder));

// EXTERNAL MODULE: ./node_modules/react-calendly/dist/index.es.js
var index_es = __webpack_require__(20761);
// EXTERNAL MODULE: ./utils/useCalendly.tsx
var useCalendly = __webpack_require__(45638);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
;// CONCATENATED MODULE: ./utils/sendGAAndGTMPurchaseEvent.ts




function sendGAAndGTMPurchaseEvent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sendPurchaseGA(lastOrder) {
    if (!lastOrder) return;
    var order_purchased = JSON.parse(localStorage.getItem('order_purchased'));
    if (localStorage.getItem('Payment type') === '3dSecure' && (order_purchased === null || order_purchased === void 0 ? void 0 : order_purchased.tokenValue) !== lastOrder.tokenValue && (order_purchased === null || order_purchased === void 0 ? void 0 : order_purchased.checkoutCompletedAt) !== lastOrder.checkoutCompletedAt) {
        var ref, ref1, ref2;
        var gaParams = {
            transaction_id: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.tokenValue,
            currency: lastOrder.currency,
            value: (0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref = lastOrder.totals) === null || ref === void 0 ? void 0 : ref.total),
            tax: (0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref1 = lastOrder.totals) === null || ref1 === void 0 ? void 0 : ref1.taxes),
            shipping: (0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref2 = lastOrder.totals) === null || ref2 === void 0 ? void 0 : ref2.shipping),
            payment_method: '3dSecure',
            items: lastOrder.items.map(function(param) {
                var product = param.product, quantity = param.quantity, total = param.total;
                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                var _obj;
                return _obj = {}, sendGAAndGTMPurchaseEvent_defineProperty(_obj, 'item_name', product.name), sendGAAndGTMPurchaseEvent_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku : product.code), sendGAAndGTMPurchaseEvent_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.code)), sendGAAndGTMPurchaseEvent_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), sendGAAndGTMPurchaseEvent_defineProperty(_obj, "quantity", quantity), _obj;
            })
        };
        localStorage.setItem('order_purchased', JSON.stringify({
            tokenValue: lastOrder.tokenValue,
            checkoutCompletedAt: lastOrder.checkoutCompletedAt
        }));
        var cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
        gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
    }
}
function sendPurchaseGTM(lastOrder) {
    if (!lastOrder) return;
    var order_purchased = JSON.parse(localStorage.getItem('order_purchased'));
    if ((order_purchased === null || order_purchased === void 0 ? void 0 : order_purchased.tokenValue) !== lastOrder.tokenValue && (order_purchased === null || order_purchased === void 0 ? void 0 : order_purchased.checkoutCompletedAt) !== lastOrder.checkoutCompletedAt) {
        var ref7, ref3, ref4, ref5;
        var gtmParams = {
            event: base/* GTMEvent.PURCHASE */.tz.PURCHASE,
            ecommerce: {
                transaction_id: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.tokenValue,
                value: (0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref7 = lastOrder.totals) === null || ref7 === void 0 ? void 0 : ref7.total),
                tax: (0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref3 = lastOrder.totals) === null || ref3 === void 0 ? void 0 : ref3.taxes),
                shipping: (0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref4 = lastOrder.totals) === null || ref4 === void 0 ? void 0 : ref4.shipping),
                discount: -(0,utils/* numberToPrice */.e8)(lastOrder === null || lastOrder === void 0 ? void 0 : (ref5 = lastOrder.totals) === null || ref5 === void 0 ? void 0 : ref5.promotion),
                items: lastOrder.items.map(function(param) {
                    var product = param.product, quantity = param.quantity, total = param.total, totalWithoutPromotion = param.totalWithoutPromotion;
                    var ref, ref6;
                    var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                    return {
                        affiliation: product === null || product === void 0 ? void 0 : product.channelCode,
                        coupon: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.couponCode,
                        discount: total && totalWithoutPromotion ? (0,utils/* numberToPrice */.e8)(totalWithoutPromotion - total) : 0,
                        price: (0,utils/* numberToPrice */.e8)(total),
                        currency: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.currency,
                        quantity: quantity,
                        item_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || (product === null || product === void 0 ? void 0 : product.code),
                        item_name: product === null || product === void 0 ? void 0 : product.name,
                        item_category: product === null || product === void 0 ? void 0 : (ref = product.taxons) === null || ref === void 0 ? void 0 : ref.main,
                        item_list_id: product === null || product === void 0 ? void 0 : product.slug,
                        item_list_name: product === null || product === void 0 ? void 0 : (ref6 = product.taxons) === null || ref6 === void 0 ? void 0 : ref6.main,
                        item_variant: firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.name
                    };
                })
            }
        };
        (0,gtag/* safeDataLayerPush */.Kx)(gtmParams);
    }
}

;// CONCATENATED MODULE: ./pages/confirmation.tsx
/* provided dependency */ var process = __webpack_require__(34155);























function confirmation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var confirmation_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: confirmation_defineProperty({
            backgroundColor: theme.extraColors.greyLight,
            padding: theme.spacing(4, 0)
        }, theme.breakpoints.up('lg'), {
            padding: theme.spacing(9, 0)
        }),
        rootCalendar: confirmation_defineProperty({}, theme.breakpoints.up('lg'), {
            paddingTop: 0
        }),
        bannerDisplayedOnAllPages: confirmation_defineProperty({}, theme.breakpoints.down('md'), {
            marginTop: theme.spacing(12)
        }),
        textBloc: {
            padding: theme.spacing(3),
            margin: theme.spacing(0, 0, 2),
            boxShadow: theme.shadows[1],
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius
        },
        fullHeightCol: {
            display: 'flex'
        },
        fullHeight: {
            width: '100%',
            alignSelf: 'stretch'
        },
        calendarBloc: {},
        calendarSpacer: confirmation_defineProperty({}, theme.breakpoints.up('lg'), {
            marginTop: theme.spacing(8.5)
        }),
        instaBloc: {
            padding: theme.spacing(1.5)
        },
        title: {},
        description: {},
        contactWrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        contactText: {
            marginBottom: theme.spacing(2)
        },
        textWrapper: {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            '&>div': {
                marginLeft: theme.spacing(2)
            }
        },
        textCenter: {
            textAlign: 'center'
        },
        row: {
            margin: theme.spacing(0, 0, 2)
        },
        container: {
            maxWidth: 1268
        },
        columnRight: confirmation_defineProperty({}, theme.breakpoints.up('lg'), {
            '&>div': {
            }
        }),
        emailButton: confirmation_defineProperty({
            textAlign: 'left',
            textTransform: 'none'
        }, theme.breakpoints.down('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        emailButtonIcon: {
            width: 'auto',
            maxHeight: '1.5em'
        },
        rowCode: {
            display: 'inline-flex',
            justifyContent: 'flex-start'
        },
        codeImage: {
            paddingRight: theme.spacing(1),
            width: '80px'
        },
        productCard: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            borderRadius: 10,
            padding: theme.spacing(2),
            boxShadow: theme.shadows[1]
        },
        productCardMedia: {
            width: 140,
            height: 108,
            objectFit: 'contain'
        },
        productCardContent: {
            width: 'calc(100% - 150px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: 108
        },
        imageConfirmation: {
            width: '100%'
        },
        imageWrapper: {
            width: '20%'
        },
        imageMail: {
            width: '100%'
        },
        wysiwyg: {
            '&>*': {
                margin: theme.spacing(0, 0, 2),
                '&:last-child': {
                    marginBottom: 0
                }
            },
            '& img': {
                maxWidth: '100%',
                height: 'auto',
                display: 'inline-block'
            }
        },
        linkCard: {
            display: 'block'
        },
        linkCardImg: {
            maxWidth: '100%',
            height: 'auto',
            display: 'inline-block'
        },
        linkCardTitle: {}
    });
});
function truncateString(str, num) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
}
var confirmation_mapStateToProps = function(state) {
    return {
        checkout: state.checkout,
        parameters: state.parameters,
        stores: state.stores,
        user: state.user
    };
};
var confirmation_mapDispatchToProps = {
    getConfirmationOrder: user/* getConfirmationOrder */.YK,
    deleteGhostUser: user/* deleteGhostUser */.iJ
};
var Confirmation = function(param) {
    var doc = param.doc, main = param.main, accountRes = param.accountRes, faqRes = param.faqRes, instagram = param.instagram, products = param.products, inStoreText = param.inStoreText, checkout = param.checkout, parameters = param.parameters, stores = param.stores, user = param.user, takeback = param.takeback, getConfirmationOrder1 = param.getConfirmationOrder, deleteGhostUser1 = param.deleteGhostUser, basket = param.basket, banner = param.banner;
    var ref67, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60;
    var emptyCart = (0,useCart/* useCart */.j)().emptyCart;
    var classes = confirmation_useStyles();
    var themes = (0,useTheme/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref61 = (0,useMatomo/* default */.Z)(), trackPageView = ref61.trackPageView, trackEvent = ref61.trackEvent;
    var dispatch = (0,es/* useDispatch */.I0)();
    var mail = (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref67 = doc.data) === null || ref67 === void 0 ? void 0 : ref67.email);
    var links = doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.links;
    var router = (0,next_router.useRouter)();
    var ref62;
    var lastOrder = (ref62 = user === null || user === void 0 ? void 0 : user.confirmationOrder) !== null && ref62 !== void 0 ? ref62 : null;
    var noCalendly = process.env.NO_CALENDLY;
    var calendly = (0,useCalendly/* useCalendly */._)(stores === null || stores === void 0 ? void 0 : stores.selectedStore, parameters === null || parameters === void 0 ? void 0 : (ref2 = parameters.items) === null || ref2 === void 0 ? void 0 : ref2.in_store);
    var ref63 = (0,react.useState)(false), displayPage = ref63[0], setDisplayPage = ref63[1];
    // Token de la commande qui vient d'être passée, capturé au montage avant que
    // emptyCart() ne vide 'CartToken' du localStorage.
    var ref64 = (0,react.useState)(null), confirmationToken = ref64[0], setConfirmationToken = ref64[1];
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        main,
        inStoreText
    ]);
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'Confirmation'
        });
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref65;
        var ref66;
        // Récupère la commande par token + email (route unifiée invité / connecté)
        // GET /shop-api/order/{token}/email/{email}.
        var email = (ref66 = user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.email) !== null && ref66 !== void 0 ? ref66 : user === null || user === void 0 ? void 0 : (ref65 = user.ghostUser) === null || ref65 === void 0 ? void 0 : ref65.email;
        if (confirmationToken && email) {
            getConfirmationOrder1(confirmationToken, email);
        }
    }, [
        confirmationToken,
        user === null || user === void 0 ? void 0 : (ref3 = user.user) === null || ref3 === void 0 ? void 0 : ref3.email,
        user === null || user === void 0 ? void 0 : (ref4 = user.ghostUser) === null || ref4 === void 0 ? void 0 : ref4.email
    ]);
    (0,react.useEffect)(function() {
        if (user === null || user === void 0 ? void 0 : user.ghostUser) {
            var handleDeleteGhostUser = function(url) {
                if (url !== '/confirmation') deleteGhostUser1();
            };
            router.events.on('routeChangeStart', handleDeleteGhostUser);
            return function() {
                router.events.off('routeChangeStart', handleDeleteGhostUser);
            };
        }
    }, [
        user === null || user === void 0 ? void 0 : user.ghostUser
    ]);
    (0,react.useEffect)(function() {
        sendPurchaseGA(lastOrder);
        sendPurchaseGTM(lastOrder);
    }, [
        lastOrder
    ]);
    (0,react.useEffect)(function() {
        if (router.asPath !== constants/* DEBUG */.eM) {
            if (checkout && typeof (checkout === null || checkout === void 0 ? void 0 : checkout.pdfResponse) !== 'undefined' && (checkout === null || checkout === void 0 ? void 0 : checkout.pdfResponse) !== 'Order completed') {
                if (localStorage.getItem('Payment type') !== '3dSecure') {
                    setDisplayPage(false);
                    router.push('/');
                } else {
                    setDisplayPage(true);
                    localStorage.removeItem('Payment type');
                }
            } else {
                setDisplayPage(true);
            }
        } else {
            setDisplayPage(true);
        }
    }, [
        checkout,
        router
    ]);
    (0,react.useEffect)(function() {
        // On capture le token AVANT emptyCart() : celui-ci supprime 'CartToken' du
        // localStorage, or on en a besoin pour récupérer la commande par token + email.
        setConfirmationToken(localStorage.getItem('CartToken'));
        emptyCart();
    }, []);
    if (!displayPage) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref5 = main.data) === null || ref5 === void 0 ? void 0 : ref5.logo,
        doc: main,
        t: t,
        inStoreText: inStoreText,
        "data-testid": "confirmation",
        metaTitle: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.meta_title_confirmation, t('texts:general:add_a_title')),
        metaDescription: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.meta_description_confirmation,
        metaKeywords: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.meta_keywords_confirmation,
        hideTop: true,
        takeback: takeback,
        basket: basket,
        account: accountRes,
        faq: faqRes,
        banner: banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            className: (0,clsx_m/* default */.Z)('confirmation', 'checkout', classes.root, (parameters === null || parameters === void 0 ? void 0 : (ref9 = parameters.items) === null || ref9 === void 0 ? void 0 : ref9.in_store) && !noCalendly && calendly.ready && classes.rootCalendar),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classes.container,
                "data-testid": 'confirmation',
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            lg: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.textBloc, (parameters === null || parameters === void 0 ? void 0 : (ref10 = parameters.items) === null || ref10 === void 0 ? void 0 : ref10.in_store) && !noCalendly && calendly.ready && classes.calendarSpacer),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.textWrapper,
                                        children: [
                                            (doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.confirmation) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.confirmationimage.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.imageWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: classes.imageMail,
                                                    src: doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.confirmation) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[0]) === null || ref16 === void 0 ? void 0 : ref16.confirmationimage.url,
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        className: (0,clsx_m/* default */.Z)(classes.title, 'confirmation__title'),
                                                        variant: "h3",
                                                        color: "primary",
                                                        children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.confirmation) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.title, t('texts:general:add_a_title'))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        className: classes.description,
                                                        variant: "body1",
                                                        children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref20 = doc.data) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.confirmation) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[0]) === null || ref22 === void 0 ? void 0 : ref22.desc, t('texts:general:add_a_description'))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.textBloc,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.textCenter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: classes.contactText,
                                                variant: "body1",
                                                component: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    data: doc === null || doc === void 0 ? void 0 : (ref23 = doc.data) === null || ref23 === void 0 ? void 0 : ref23.text,
                                                    defaultText: t('texts:confirmation:text')
                                                })
                                            }),
                                            (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref24 = doc.data) === null || ref24 === void 0 ? void 0 : ref24.email) && ((doc === null || doc === void 0 ? void 0 : (ref25 = doc.data) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.maillogo) === null || ref26 === void 0 ? void 0 : ref26.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "contained",
                                                size: "large",
                                                color: "secondary",
                                                component: "a",
                                                onClick: function() {
                                                    return trackEvent({
                                                        category: 'Confirmation',
                                                        href: "/".concat(mail),
                                                        action: "User click to send mail to ".concat(mail)
                                                    });
                                                },
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                href: "mailto:".concat(mail),
                                                className: classes.emailButton,
                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: doc === null || doc === void 0 ? void 0 : (ref27 = doc.data) === null || ref27 === void 0 ? void 0 : ref27.maillogo.url,
                                                    className: classes.emailButtonIcon
                                                }),
                                                children: mail
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "contained",
                                                size: "large",
                                                color: "secondary",
                                                component: "a",
                                                onClick: function() {
                                                    return trackEvent({
                                                        category: 'Confirmation',
                                                        href: "/".concat(mail),
                                                        action: "User click to send mail to ".concat(mail)
                                                    });
                                                },
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                href: "mailto:".concat(mail),
                                                className: classes.emailButton,
                                                children: mail
                                            }))
                                        ]
                                    })
                                }),
                                !!(instagram === null || instagram === void 0 ? void 0 : instagram.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.textBloc, classes.instaBloc),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstaWall/* default */.Z, {
                                        t: t,
                                        isSmall: true,
                                        data: instagram === null || instagram === void 0 ? void 0 : instagram.data
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)(classes.columnRight, !(parameters === null || parameters === void 0 ? void 0 : (ref28 = parameters.items) === null || ref28 === void 0 ? void 0 : ref28.in_store) && classes.fullHeightCol),
                            item: true,
                            xs: 12,
                            lg: 7,
                            children: [
                                (parameters === null || parameters === void 0 ? void 0 : (ref29 = parameters.items) === null || ref29 === void 0 ? void 0 : ref29.in_store) && calendly.ready && !noCalendly && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.calendarBloc,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.row,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* InlineWidget */.KS, {
                                            url: calendly.pickupUrl,
                                            styles: {
                                                height: '1100px'
                                            },
                                            pageSettings: {
                                                hideEventTypeDetails: false,
                                                hideLandingPageDetails: true,
                                                hideGdprBanner: true,
                                                primaryColor: themes.palette.primary.main.replace('#', ''),
                                                textColor: themes.palette.common.black.replace('#', '')
                                            },
                                            prefill: {
                                                email: (user === null || user === void 0 ? void 0 : (ref30 = user.user) === null || ref30 === void 0 ? void 0 : ref30.email) ? user === null || user === void 0 ? void 0 : (ref31 = user.user) === null || ref31 === void 0 ? void 0 : ref31.email : user === null || user === void 0 ? void 0 : (ref32 = user.ghostUser) === null || ref32 === void 0 ? void 0 : ref32.email,
                                                firstName: (user === null || user === void 0 ? void 0 : (ref33 = user.user) === null || ref33 === void 0 ? void 0 : ref33.firstName) ? user === null || user === void 0 ? void 0 : (ref34 = user.user) === null || ref34 === void 0 ? void 0 : ref34.firstName : user === null || user === void 0 ? void 0 : (ref35 = user.ghostUser) === null || ref35 === void 0 ? void 0 : ref35.firstName,
                                                lastName: (user === null || user === void 0 ? void 0 : (ref36 = user.user) === null || ref36 === void 0 ? void 0 : ref36.lastName) ? user === null || user === void 0 ? void 0 : (ref37 = user.user) === null || ref37 === void 0 ? void 0 : ref37.lastName : user === null || user === void 0 ? void 0 : (ref38 = user.ghostUser) === null || ref38 === void 0 ? void 0 : ref38.lastName,
                                                customAnswers: {
                                                    a1: (lastOrder === null || lastOrder === void 0 ? void 0 : (ref39 = lastOrder.items) === null || ref39 === void 0 ? void 0 : ref39.length) > 0 ? lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.number : '',
                                                    a2: (user === null || user === void 0 ? void 0 : (ref40 = user.user) === null || ref40 === void 0 ? void 0 : ref40.phoneNumber) ? user === null || user === void 0 ? void 0 : (ref41 = user.user) === null || ref41 === void 0 ? void 0 : ref41.phoneNumber : ''
                                                }
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.textBloc, !(parameters === null || parameters === void 0 ? void 0 : (ref42 = parameters.items) === null || ref42 === void 0 ? void 0 : ref42.in_store) && classes.fullHeight),
                                    children: [
                                        lastOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_RecapOrder, {
                                            doc: doc,
                                            settings: main === null || main === void 0 ? void 0 : main.data,
                                            t: t,
                                            showSizes: main === null || main === void 0 ? void 0 : (ref43 = main.data) === null || ref43 === void 0 ? void 0 : ref43.show_size_name,
                                            showPrice: !(main === null || main === void 0 ? void 0 : (ref44 = main.data) === null || ref44 === void 0 ? void 0 : ref44.only_add_with_pack),
                                            lastOrder: lastOrder,
                                            takeBack: takeback
                                        }),
                                        (!constants/* isSubscription */.Nn || (doc === null || doc === void 0 ? void 0 : (ref45 = doc.data) === null || ref45 === void 0 ? void 0 : ref45.active_on_sub)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.row,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "h4",
                                                            component: "h3",
                                                            children: [
                                                                ' ',
                                                                (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref46 = doc.data) === null || ref46 === void 0 ? void 0 : ref46.title_complements, t('confirmation:title_complements'))
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref47 = doc.data) === null || ref47 === void 0 ? void 0 : ref47.desc_complements, t('confirmation:desc_complements'))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.row,
                                                    children: (doc === null || doc === void 0 ? void 0 : (ref48 = doc.data) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.codeimage) === null || ref49 === void 0 ? void 0 : ref49.url) && (doc === null || doc === void 0 ? void 0 : (ref50 = doc.data) === null || ref50 === void 0 ? void 0 : ref50.codetext) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.textBloc, classes.rowCode),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: (doc === null || doc === void 0 ? void 0 : (ref51 = doc.data) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.codeimage) === null || ref52 === void 0 ? void 0 : ref52.url) ? doc === null || doc === void 0 ? void 0 : (ref53 = doc.data) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.codeimage) === null || ref54 === void 0 ? void 0 : ref54.url : '/images/placeholder.jpg',
                                                                alt: doc === null || doc === void 0 ? void 0 : (ref55 = doc.data) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.codeimage) === null || ref56 === void 0 ? void 0 : ref56.url,
                                                                className: classes.codeImage
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: 'body1',
                                                                        children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref57 = doc.data) === null || ref57 === void 0 ? void 0 : ref57.codetext, t('confirmation:codetext'))
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: 'body1',
                                                                        color: 'secondary',
                                                                        children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref58 = doc.data) === null || ref58 === void 0 ? void 0 : ref58.codename, t('confirmation:codename'))
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref59 = doc.data) === null || ref59 === void 0 ? void 0 : ref59.succes_text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.wysiwyg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        data: doc === null || doc === void 0 ? void 0 : (ref60 = doc.data) === null || ref60 === void 0 ? void 0 : ref60.succes_text
                                                    })
                                                }),
                                                links && links.map(function(link, index) {
                                                    var ref, ref68, ref69, ref70, ref71;
                                                    return (link === null || link === void 0 ? void 0 : (ref = link.link_url) === null || ref === void 0 ? void 0 : ref.url) && (link === null || link === void 0 ? void 0 : (ref68 = link.link_url) === null || ref68 === void 0 ? void 0 : ref68.url.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: link.link_url.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: (0,clsx_m/* default */.Z)('link-card', classes.linkCard),
                                                            target: ((ref69 = link.link_url) === null || ref69 === void 0 ? void 0 : ref69.target) === '_blank' ? '_blank' : '_self',
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: 'h4',
                                                                    component: "div",
                                                                    className: (0,clsx_m/* default */.Z)('link-card__title', classes.linkCardTitle),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                        data: link === null || link === void 0 ? void 0 : link.link_text
                                                                    })
                                                                }),
                                                                (link === null || link === void 0 ? void 0 : (ref70 = link.image) === null || ref70 === void 0 ? void 0 : ref70.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: (0,clsx_m/* default */.Z)('link-card__img', classes.linkCardImg),
                                                                    src: link === null || link === void 0 ? void 0 : (ref71 = link.image) === null || ref71 === void 0 ? void 0 : ref71.url,
                                                                    alt: ''
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                }),
                                                products && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: products.map(function(product1) {
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                                    container: true,
                                                                    spacing: 2,
                                                                    justify: "space-between",
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                            item: true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                variant: "h4",
                                                                                component: "h2",
                                                                                children: (0,CMSText/* prismicText */.yz)(product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.products_category)
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                            item: true,
                                                                            children: typeof product1.data.products_category_link.url !== 'undefined' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                                href: product1.data.products_category_link.url,
                                                                                passHref: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                    component: "a",
                                                                                    target: "_blank",
                                                                                    rel: "noopener noreferrer",
                                                                                    size: "small",
                                                                                    color: "primary",
                                                                                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                                    children: (0,CMSText/* prismicText */.yz)(product1.data.see_more)
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: classes.row,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                        container: true,
                                                                        spacing: 2,
                                                                        children: product1.data.products_list.map(function(product, index) {
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                                item: true,
                                                                                sm: 12,
                                                                                lg: 6,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: classes.productCard,
                                                                                    children: [
                                                                                        typeof product.product_image.url !== 'undefined' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                            src: product.product_image.url,
                                                                                            alt: "",
                                                                                            className: classes.productCardMedia
                                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                                            variant: "rect",
                                                                                            animation: false,
                                                                                            width: 140,
                                                                                            height: 108
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: classes.productCardContent,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                                    variant: "body2",
                                                                                                    children: truncateString((0,CMSText/* prismicText */.yz)(product.product_name), 50)
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    children: typeof product.product_url.url !== 'undefined' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                                                        href: product.product_url.url,
                                                                                                        passHref: true,
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                                            component: "a",
                                                                                                            size: "small",
                                                                                                            variant: "contained",
                                                                                                            color: "secondary",
                                                                                                            onClick: function() {
                                                                                                                return trackEvent({
                                                                                                                    category: 'Confirmation',
                                                                                                                    action: "Go to product to buy ".concat(product.product_url.url)
                                                                                                                });
                                                                                                            },
                                                                                                            target: "_blank",
                                                                                                            rel: "noopener noreferrer",
                                                                                                            children: (0,CMSText/* prismicText */.yz)(products[0].data.buy_button)
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, "product-".concat(index));
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, product1.id);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var confirmation = ((0,es/* connect */.$j)(confirmation_mapStateToProps, confirmation_mapDispatchToProps)(Confirmation));


/***/ }),

/***/ 89910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jC": function() { return /* binding */ billingAddressForThermorCheckoutPut; },
/* harmony export */   "wR": function() { return /* binding */ getCartSecondHandItems; },
/* harmony export */   "Vk": function() { return /* binding */ getCurrentSkuProductInCart; },
/* harmony export */   "_y": function() { return /* binding */ getCurrentProductTypeInCart; },
/* harmony export */   "Lj": function() { return /* binding */ getSecondHandProductInformation; },
/* harmony export */   "Ci": function() { return /* binding */ isOnlySecondHandInCart; }
/* harmony export */ });
/* unused harmony exports getCartSecondHandItem, getProductTypeInCart, getProductsTypeInCart */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66026);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var cartHasPersistedBilling = function(b) {
    var ref, ref1;
    return !!(b && (((ref = b.street) === null || ref === void 0 ? void 0 : ref.trim()) || ((ref1 = b.postcode) === null || ref1 === void 0 ? void 0 : ref1.trim())));
};
/**
 * Si Thermor SSO et que le panier a déjà une facturation, renvoie celle du panier ;
 * sinon la valeur proposée (ex. formulaire ou profil).
 */ var billingAddressForThermorCheckoutPut = function(proposed, cartItem) {
    if (!_constants__WEBPACK_IMPORTED_MODULE_0__/* .isThermorSSO */ .y || !cartItem) return proposed;
    var existing = cartItem.billingAddress;
    if (cartHasPersistedBilling(existing)) return _objectSpread({}, existing);
    return proposed;
};
// format second hand informations from cart
var getCartSecondHandItem = function(item) {
    var units = item.units.map(function(unit) {
        return {
            productState: unit.productCondition,
            productPuid: unit.puid
        };
    });
    return {
        sku: item.product.variants[0].sku,
        units: units
    };
};
// get all informations about 2nde hand products in cart according cartSecondHandItems typing
var getCartSecondHandItems = function(cart) {
    var ref, ref2;
    return (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref2 = ref.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
        return getCartSecondHandItem(item);
    })) || [];
};
// get second hand informations products in cart for according current sku
var getCurrentSkuProductInCart = function(secondHandProductsInCart, currentSku) {
    return secondHandProductsInCart === null || secondHandProductsInCart === void 0 ? void 0 : secondHandProductsInCart.filter(function(secondHandProduct) {
        return secondHandProduct.sku === currentSku;
    });
};
// get type of products in cart (second hand or rental)
var getProductTypeInCart = function(item) {
    var ref;
    return {
        code: item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.code,
        type: item === null || item === void 0 ? void 0 : item.type
    };
};
var getProductsTypeInCart = function(cart) {
    var ref, ref3;
    return cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref3 = ref.items) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
        return getProductTypeInCart(item);
    });
};
// get type of current product in cart (case of rent and 2nde hand)
var getCurrentProductTypeInCart = function(currentItem, cart) {
    var productsInCartWithType = getProductsTypeInCart(cart);
    var currentItemCode = currentItem.code;
    var currentProductInCart = productsInCartWithType === null || productsInCartWithType === void 0 ? void 0 : productsInCartWithType.find(function(product) {
        return product.code === currentItemCode;
    });
    if (!currentProductInCart) return null;
    return currentProductInCart.type;
};
// second hand informations to display them on confirmation's page
var getSecondHandProductInformation = function(secondHandProduct) {
    var ref, ref4, ref5, ref6;
    var units = secondHandProduct.units.map(function(unit) {
        return {
            productState: unit.productCondition,
            productPuid: unit.puid,
            productPrice: unit.price
        };
    });
    return {
        productName: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : (ref = secondHandProduct.product) === null || ref === void 0 ? void 0 : ref.name,
        productImage: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : (ref4 = secondHandProduct.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.images) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.cachedPath,
        units: units,
        taxonPromotionPercent: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : secondHandProduct.taxonPromotionPercent
    };
};
// there is only second hand in cart
var isOnlySecondHandInCart = function(cart) {
    var ref;
    return !((ref = getProductsTypeInCart(cart)) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_ITEM_TYPE.RENTAL */ ._$.RENTAL;
    }));
};


/***/ }),

/***/ 45638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useCalendly; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useCalendly = function(selectedStore, isInstore) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), ready = ref[0], setReady = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), returnUrl = ref1[0], setReturnUrl = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), pickupUrl = ref2[0], setPickupUrl = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (selectedStore && isInstore) {
            setReturnUrl(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.calendlyReturnUrl);
            setPickupUrl(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.calendlyWithdrawalUrl);
            setReady(true);
        }
    }, [
        selectedStore,
        isInstore
    ]);
    return {
        ready: ready,
        returnUrl: returnUrl,
        pickupUrl: pickupUrl
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,20761,230,19789,29705,79956,86192,26699,49774,92888,40179], function() { return __webpack_exec__(69853); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);